import { NavigationItem } from '../types'

export const mainNavigation: NavigationItem[] = [
  { name: 'nav.home', href: '/' },
  { name: 'nav.about', href: '/about' },
  { name: 'nav.vision', href: '/vision' },
  { name: 'nav.mission', href: '/mission' },
  { name: 'nav.innovation', href: '/innovation' },
  { name: 'nav.products', href: '/products' },
  { name: 'nav.scenarios', href: '/scenarios' },
  { name: 'nav.careers', href: '/careers' },
  { name: 'nav.contact', href: '/contact' },
]

export const footerNavigation = {
  company: [
    { name: 'footer.company.about', href: '/about' },
    { name: 'footer.company.vision', href: '/vision' },
    { name: 'footer.company.mission', href: '/mission' },
    { name: 'footer.company.innovation', href: '/innovation' },
  ],
  products: [
    { name: 'footer.products.onesoul', href: '/products#one-soul' },
    { name: 'footer.products.onebody', href: '/products#one-body' },
    { name: 'footer.products.toolchain', href: '/products#toolchain' },
  ],
  resources: [
    { name: 'footer.resources.docs', href: '/docs', isExternal: true },
    { name: 'footer.resources.community', href: '/community', isExternal: true },
    { name: 'footer.resources.api', href: '/api-docs', isExternal: true },
    { name: 'footer.resources.demo', href: '/demo', isExternal: true },
  ],
  legal: [
    { name: 'footer.legal.privacy', href: '/privacy' },
    { name: 'footer.legal.terms', href: '/terms' },
    { name: 'footer.legal.legal', href: '/legal' },
  ],
} 